import React, { useState, useEffect } from 'react';
import MicRecorder from 'mic-recorder-to-mp3';
import io from 'socket.io-client';
import { BsPlay, BsStop } from 'react-icons/bs' ;
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { TiTick } from 'react-icons/ti';
import { RingLoader } from "react-spinners";
import { alert_error , alert_success  } from '../AppContext';
const Mp3Recorder = new MicRecorder({ bitRate: 128 });

const Liveaudio = () => {
  const [countdown, setCountdown] = useState(null);
  const [isRecording, setIsRecording] = useState(false);
  const [blobURL, setBlobURL] = useState('');
  const [isBlocked, setIsBlocked] = useState(false);
  const [dalaythongtin, setdalaythongtin] = useState(false);
  const [thongtincum, setthongtincum] = useState(false);
  const [ThietBiId, setThietBiId] = useState(false);
  const [ToChucIds, setToChucIds] = useState(false);
  const { slug_2  } = useParams();
  const [intervalId, setIntervalId] = useState(null);
  console.log(slug_2 ); // In ra: 0986565156
  // const socket = io('http://103.200.20.147:3001');
  function laythongtin()
  {
    axios.get('https://hust.media/truyenthanh/usercum.php', {
        params: {
          username: slug_2
        }
      })
        .then(response => {
          console.log(response.data); // Dữ liệu từ API
          setdalaythongtin(true);
          setthongtincum(response.data.Data);
          setToChucIds(parseInt(response.data.ToChucIds));
console.log(ToChucIds); // 7134

          // Xử lý dữ liệu ở đây
        })
        .catch(error => {
            alert_error(error);
        });
  };
  function liveon()
  {
    axios.get('https://hust.media/truyenthanh/liveon.php', {
        params: {
            ToChucIds: ToChucIds ,
          ThietBiId: ThietBiId
        }
      })
        .then(response => {
          console.log(response.data); // Dữ liệu từ API
          // Xử lý dữ liệu ở đây
        })
        .catch(error => {
            alert_error(error);
        });
  };
  useEffect(() => {
 laythongtin() ;
 console.log('Permission Granted');
 setIsBlocked(false);
  }, []);
  useEffect(() => {
    if (countdown > 0 && isRecording) {
      const intervalId = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);

      return () => clearInterval(intervalId);
    }

    if (countdown === 0) {
      // Start recording logic here
      alert_success('Đang bắt đầu phát trực tuyến');
      setCountdown(null);
    }
  }, [countdown, isRecording]);
  const startRecording = () => {

    if (isBlocked) {
        alert_error('Mic bị lỗi');
    } else if (ThietBiId) {
          // liveon();
          
      // socket.emit('startRecording');
  
      Mp3Recorder.start()
        .then(() => {
          setIsRecording(true);
          setCountdown(5);
          startSendingAudio();
        })
        .catch((e) => console.error(e));
    }
    else
    {
        alert_error('chưa chọn cụm phát');
    }
  };
function liveoff()
{setdalaythongtin(false);
        axios.get('https://hust.media/truyenthanh/liveoff.php')
          .then(function (response) {
            console.log(response.data);
            setdalaythongtin(true);
            alert_success('Đã tắt livestream');
          })
          .catch(function (error) {
            alert_error('Lỗi mạng vui lòng tải lại trang');
          });
};
  const stopRecording = () => {
    liveoff();
    clearInterval(intervalId);
    setIntervalId(null);
    // socket.emit('stopRecording');
    // socket.disconnect();
    Mp3Recorder.stop()
      .getMp3()
      .then(([buffer, blob]) => {
        const blobURL = URL.createObjectURL(blob);
        setBlobURL(blobURL);
        setIsRecording(false);
        sendAudioData(blob);
      })
      .catch((e) => console.log(e));
  };

  const sendAudioData = (audioBlob) => {
    const formData = new FormData();

    formData.append('audio', audioBlob);

    // Thay đổi URL và tùy chỉnh các tham số phù hợp với API của bạn
    fetch('http://171.228.241.141:3001', {
      method: 'POST',
      body: formData,
    })
      .then((response) => {
        // Xử lý phản hồi từ server (nếu cần)
        console.log('Server response:', response);
      })
      .catch((error) => {
        console.error('Error sending audio data:', error);
      });
  };

  const startSendingAudio = () => {
   
    const id = setInterval(() => {
      Mp3Recorder
        .getMp3()
        .then(([buffer, blob]) => {
          sendAudioData(blob);
        })
        .catch((e) => console.log(e));
    }, 2000);
    setIntervalId(id);
  };

  const handleClick = (itemId) => {
    setThietBiId(itemId);
  };
  return (
    <>
      {!dalaythongtin && !thongtincum ? (
        <div className="flex justify-center items-center">
          <RingLoader size={80} color="#0000ff" loading={dalaythongtin} />{" "}
        </div>
      ) : (
    <div className="max-w-2xl px-1 py-4   mx-auto rounded-lg shadow-xl ">
    <div className="container-fluid mt-3  flex  flex-col  items-center justify-center">
      <button
        className={`bg-blue-500 w-full hover:bg-blue-700 text-white font-bold py-3 px-4 rounded ${isRecording ? 'opacity-50 cursor-not-allowed' : 'opacity-100 cursor-pointer'}`}
        onClick={startRecording}
        disabled={isRecording}
      >
      
      <p className="text-lg">
          {countdown > 0 ? countdown : <><BsPlay className="inline-block mr-2 text-2xl" /> Bắt đầu phát trực tuyến</>}
        </p>
      </button>
      
      <button
        className={`mt-4 bg-red-500 w-full hover:bg-red-700 text-white font-bold py-2 px-4 rounded ${!isRecording ? 'opacity-50 cursor-not-allowed' : 'opacity-100 cursor-pointer'}`}
        onClick={stopRecording}
        disabled={!isRecording}
      >
     <p className="text-lg"> <BsStop className="inline-block mr-2 text-2xl" /> Dừng phát trực tuyến </p>   
      </button>
      
    </div>
    <div className="grid mt-3 grid-cols-2 gap-4">
      {thongtincum.map((item) => (
        <div
          key={item.Id}
          className={`bg-gray-200 p-4 rounded-lg cursor-pointer ${
            ThietBiId === item.Id ? 'bg-green-200' : ''
          }`}
          onClick={() => handleClick(item.Id)}
        >
          <div className="flex items-center justify-center mb-2">
            {ThietBiId === item.Id && (
              <TiTick className="w-10 h-10 text-green-500" />
            )}
          </div>
          <p className="text-center">{item.TenThietBi}</p>
        </div>
      ))}
    </div>
    {/* {blobURL && (
      <audio src={blobURL} controls className="mt-4" />
    )} */}
  </div> ) }
    </>
  
  );
};

export default Liveaudio;
